import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import InviteModal from "../Invitations/InviteModal";
import useRoleCheck from "../../../hooks/useRoleCheck";
import { Button } from "../../ui/button";
import { PlusIcon } from "lucide-react";
import { Badge } from "../../ui/badge";
import GenericModal from "../../GenericModal";
import useModal from "../../GenericModal/useModal";
import MembershipRequests from "./MembershipRequests";
import Text from "../../Tags/Text";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs";
import ActiveMembers from "./ActiveMembers";
import Invitations from "./Invitations";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import PageHeader from "../../PageHeader";
export default function Members() {
  const { activeWorkspace } = useRoleCheck();
  const captureEvent = useCaptureEvent();
  const location = useLocation();
  const navigate = useNavigate();
  const { workspaceSlug } = useParams();

  // handle invite modal
  const { isOpen, openModal, closeModal } = useModal(false);

  // get count of members
  const [membersCount, setMembersCount] = useState();
  const getMembersCount = (count) => {
    setMembersCount(count);
  };

  // get count of requests
  const [requestCount, setRequestCount] = useState();
  const getRequestCount = (count) => {
    setRequestCount(count);
  };

  // get count of invitations
  const [invitationCount, setInvitationCount] = useState();
  const getInvitationCount = (count) => {
    setInvitationCount(count);
  };

  const getActiveTab = () => {
    if (location.pathname.endsWith("/requests")) return "request";
    if (location.pathname.endsWith("/invitations")) return "invitation";
    return "active";
  };

  const activeTab = getActiveTab();

  const handleTabChange = (val) => {
    const basePath = `/${workspaceSlug}/settings/members`;
    if (val === "active") {
      navigate(basePath);
      captureEvent("SET_Members_ActiveBtn");
    }
    if (val === "request") {
      navigate(`${basePath}/requests`);
      captureEvent("SET_Members_RequestBtn");
    }
    if (val === "invitation") {
      navigate(`${basePath}/invitations`);
      captureEvent("SET_Members_InvitationsBtn");
    }
  };

  return (
    <>
      <PageHeader
        heading="Members"
        description="Manage workspace users and requests"
        cta={
          <Button
            onClick={() => {
              openModal();
              captureEvent("SET_Members_InviteMembers");
            }}
            type="button"
          >
            <PlusIcon className="h-5 w-5 mr-2" aria-hidden="true" />
            Invite Members
          </Button>
        }
      />

      <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full mt-6">
        <TabsList className="w-full">
          <TabsTrigger value="active">
            Active{" "}
            {/* {membersCount >= 0 && (
              <Badge className="ml-2">{membersCount}</Badge>
            )} */}
          </TabsTrigger>
          <TabsTrigger value="request">
            Requests{" "}
            {requestCount >= 0 && (
              <Badge variant="warning" className="ml-2">
                {requestCount}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="invitation">
            Invitations
            {/* {invitationCount >= 0 && (
              <Badge className="ml-2">{invitationCount}</Badge>
            )} */}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="active">
          <ActiveMembers getCount={getMembersCount} />
        </TabsContent>
        <TabsContent value="request">
          <MembershipRequests getCount={getRequestCount} />
        </TabsContent>
        <TabsContent value="invitation">
          <Invitations getCount={getInvitationCount} />
        </TabsContent>
      </Tabs>

      <GenericModal isOpen={isOpen} closeModal={closeModal}>
        <InviteModal closeModal={closeModal} activeWorkspace={activeWorkspace} />
      </GenericModal>
    </>
  );
}
